export default {
  editAccount: 'Edit Akun',
  uploadPhoto: 'Unggah Foto',
  username: 'Username : ',
  company: 'Company : ',
  email: 'Email : ',
  phoneNumber: 'Nomor Telpon : ',
  submit: 'Submit',
  detailAccount: 'Detil Akun',
  edit: 'Edit',
  oldPassword: 'Masukkan sandi lama',
  newPassword: 'Masukkan sandi baru',
  repeatPassword: 'Masukkan ulang sandi baru ',
  now: 'Sandi Lama : ',
  next: 'Sandi Baru : ',
  repeat: 'Ulang Sandi : ',
  successPassword: 'Berhasil Mengubah Password',
  error: {
    emptyForm: 'Mohon masukkan sandi',
    notMatch: 'Sandi yang dimasukkan tidak sama',
    inputAgain: 'Mohon masukkan sandi sekali lagi',
    emptyOldPass: 'Mohon masukkan sandi saat ini terlebih dahulu',
    minimumLength: 'Password harus lebih dari 6 karakter'
  }
}
